import { Input } from 'antd';
import { QuestionType } from 'common/enum';
import { useEffect, useState } from 'react';

type Props = {
  commitChange: (dataChange: any, rightAnswer: string | number | undefined | null, questionType: QuestionType) => void;
  rightAnswer: string | number | undefined | null;
};

export default function EditYesNoQuestion({ commitChange, rightAnswer }: Props) {
  const [rightAnswerEdit, setRightAnswerEdit] = useState<string | number | undefined | null>(rightAnswer);

  const onChangeRadio = function (e: any) {
    const changeValues = e.target.value;
    commitChange(null, changeValues, QuestionType.YES_NO_QUESTION);
  };

  useEffect(() => {
    setRightAnswerEdit(rightAnswer);
  }, [rightAnswer]);

  return (
    <div className="flex w-fit items-center gap-2">
      <span>Đúng</span>
      <Input
        type="radio"
        className="w-[20px] h-[20px]"
        name="choice-anwser"
        value="1"
        checked={rightAnswerEdit !== null && rightAnswer !== undefined && Number(rightAnswerEdit) === 1}
        onChange={(e) => {
          onChangeRadio(e);
        }}
      />
      <span>Sai</span>
      <Input
        type="radio"
        className="w-[20px] h-[20px]"
        name="choice-anwser"
        value="0"
        checked={
          rightAnswerEdit !== null &&
          rightAnswerEdit !== undefined &&
          rightAnswerEdit !== '' &&
          Number(rightAnswerEdit) === 0
        }
        onChange={(e) => {
          onChangeRadio(e);
        }}
      />
    </div>
  );
}
